
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import {Chart, ChartConfiguration} from 'chart.js'
import { getColors } from '../../global/utils'
import AppChart from '../../global/components/AppChart.vue'

type RevenueStatInfo = {
  title: string;
  total: { providerShare: number; agencyShare: number };
  data: { id: number; providerShare: number; agencyShare: number}[];
}

@Component
export default class RevenueChart extends Vue {
  private revenueChartConfig: ChartConfiguration<'doughnut', number[], string> | null = null

  private get chart() {
    return this.$refs.chart as AppChart<'doughnut', number>
  }

  mounted() {
    this.getRevenueStatsData()
  }

  async getRevenueStatsData() {
    const response = await axios.get<RevenueStatInfo>('/stats/revenue')
    const config = this.formatRevenueChartConfig(response.data)
    this.chart.loadConfig(config)
    const total = response.data.total.agencyShare + response.data.total.providerShare
    this.$emit('total', total)
  }

  private formatRevenueChartConfig(chartInfo: RevenueStatInfo): ChartConfiguration<'doughnut', number[], string> {
    return {
      type: 'doughnut',
      data: {
        labels: ['Provider Payout','Agency Payout'],
        datasets: [{
          data: [chartInfo.total.providerShare / 100, chartInfo.total.agencyShare / 100],
          backgroundColor: getColors(2)
        }]
      },
      options: {
        plugins: {
          legend: {
            display: true
          },
          title: {
            display: true,
            text: chartInfo.title
          },
          tooltip: {
            position: 'nearest',
            callbacks: {
              label: (item) => {
                return `${item.label}: $${(+item.parsed).toFixed(2)}`
              },
            }
          }
        }
      },
      plugins: [
        {
          id: 'view-report',
          beforeEvent: this.handleChartEvent.bind(this)
        }
      ]
    }
  }

  handleChartEvent(chart: any, args: any): void {
    const event = args.event;
    if (event.type === 'click') {
      this.click()
    }
  }

  click():void {
    this.$router.push({ name: 'reports-page' })
  }
}
